import React, { useMemo } from 'react';
import {
  Box,
  Popover,
  Button,
  IconButton,
  Typography,
  Divider,
  Breadcrumbs,
  Link,
  Select,
  ListItemIcon,
  ListItemText,
  ListItem,
} from '@material-ui/core';
import indexOf from 'lodash/indexOf';
import orderBy from 'lodash/orderBy';
import { Description, Folder } from '@material-ui/icons';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';
import get from 'lodash/get';
import Header from '../../components/Header';
import classes from './Document.module.scss';
import FileManagement from './components/FileManagement';
import DocumentMenu from './components/Menu';
import AddNewModal from './components/Modal/AddNewTab';
import DeleteModal from './components/Modal/DeleteModal';
import ShareFiles from 'views/Product/ProductProfile/components/ShareFiles';
import FileSystemNavigator from 'views/Product/ProductProfile/components/FileSystemNavigator';
import flattenDeep from 'lodash/flattenDeep';
import { TABS, MENUS } from '../../constants';
import SearchBox from '../../components/SearchBox';
import CheckIcon from '@material-ui/icons/Check';
import { SearchWithSuggestionProvider } from 'context';
import T from 'i18n-react';
import { PRODUCT_MANAGEMENT_PATH } from 'shared/path';
import { setLanguageLocale } from 'util/icwUtility';
import { QMASDocumentUpload } from 'components/Molecules/Upload/index';
import DocumentsTab from './DocumentsTab';
import { TAB_KEYS, TAB_LABELS } from './DocumentsTab/constants';
import NewFolderModal from './components/NewFolderModal';
import { useActions } from './selectorData';
import { getParentFolders } from './utils';

setLanguageLocale(T, [PRODUCT_MANAGEMENT_PATH]);

let reloadAllFn = {};
let handleShowUploadModal = null;

const DocumentSections = ({
  companyId,
  productId,
  productTabs = [],
  onCreateTab,
  onUpdateTab,
  onDeleteTab,
  onChangeTab,
  handleCreateFolder,
  handleCreateFiles,
  onBulkDownload,
  uploadFile,
  shareFile,
  files = {},
  handleUpdateExpiryDate,
  handleUpdateReminder,
  handleDeleteFileOrFolder,
  handleRename,
  handleMoveFileFolder,
  viewLocation,
  searchFile,
  onRefresh,
  isActive,
  onOpenMarkActiveModal,
  product,
  loadExpiredFiles,
  ...props
}) => {
  const hideNewUI = false;
  const { createProductFolder } = useActions();
  const willDeletedTab = React.useRef([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [selectedRowKeys, setSelectedRowKeys] = React.useState({});
  const [selectedRows, setSelectedRows] = React.useState({});
  const [editMode, setEditMode] = React.useState(false);
  const [editItem, setEditItem] = React.useState(undefined);
  const [addingNewTab, setAddingNewTab] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [currentTabKey, setCurrentTabKey] = React.useState(TAB_KEYS.ALL_JOB);
  const [selectedFolders, setSelectedFolders] = React.useState({
    [TAB_KEYS.ALL_JOB]: [],
    [TAB_KEYS.ARCHIVED]: [],
  });
  const currentSelectedFolders = selectedFolders?.[currentTabKey] || [];
  const currentSelectedRows = selectedRows[currentTabKey];
  const [tabs, setTabs] = React.useState(TABS);
  const [activeTab, setActiveTab] = React.useState('inspection');
  const [folders, setFolders] = React.useState([]);
  const [showMore, setShowMore] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openShareFiles, setShareFiles] = React.useState(false);
  const [openFilesNav, setFilesNav] = React.useState(false);
  const [isAddNewFolder, setIsAddNewFolder] = React.useState(false);
  const [action, setAction] = React.useState('');
  const searchType = React.useRef('all');
  const [currentSearchType, setCurrentSearchType] = React.useState('all');
  const [selected, setSelected] = React.useState({
    inspection: [],
    testing: [],
    document: [],
  });
  const onClickMore = (event) => {
    if (editMode) return;
    setAnchorEl(event.currentTarget);
    setShowMore(true);
  };
  const handleDeleteTab = (item) => {
    setShowDeleteModal(false);
    setEditItem(null);
    setEditMode(false);
    const newTabs = tabs.filter((tab, index) => index !== item.id);
    setTabs([...newTabs]);
    setActiveTab(newTabs[newTabs.length - 1] || activeTab);
    onDeleteTab({ name: item.value });
    enqueueSnackbar('Tab deleted', {
      key: `${item.value}-${item.id}-tab-deleted-success`,
      className: classes.snackbarSuccess,
      autoHideDuration: 8000,
      action: (
        <>
          <IconButton
            onClick={() => {
              closeSnackbar(`${item.value}-${item.id}-tab-deleted-success`);
            }}>
            <CloseIcon />
          </IconButton>
        </>
      ),
    });
  };
  const handleSearch = React.useCallback(
    ({ searchBy, value, searchType = currentSearchType }, cb) => {
      let params = {
        isDeleted: false,
        [`${searchBy}_like`]: `${value}`,
      };
      searchFile(productId, params, (response) => {
        if (response) {
          const { data } = response.data;
          cb(data);
        }
      });
    },
    [currentSearchType]
  );
  const transformFiles = useMemo(() => {
    return Object.keys(files).reduce((acc, current) => {
      const { fileArr } = files[current];
      return { ...acc, [current]: fileArr };
    }, {});
  }, [files]);
  const menusSearchType = React.useMemo(() => {
    const menus = [
      {
        icon: currentSearchType === 'current-folder' ? <CheckIcon></CheckIcon> : null,
        label: 'Current folder',
        action: 'current-folder',
      },
      {
        icon: currentSearchType === 'all' ? <CheckIcon></CheckIcon> : null,
        label: 'All locations',
        action: 'all',
      },
      {
        icon: currentSearchType === 'current-tab' ? <CheckIcon></CheckIcon> : null,
        label: 'Current tab',
        action: 'current-tab',
      },
    ];
    if (folders.length) return menus;
    menus.splice(0, 1);
    return menus;
  }, [currentSearchType, folders]);
  const handleSelectFolder = (obj, tArr, mode) => {
    setSelectedFolders((prevSelectedFolders) => {
      const newSelectedFolders = {
        ...prevSelectedFolders,
        [currentTabKey]: tArr ? tArr : [...(prevSelectedFolders[currentTabKey] || []), obj],
      };
      const currentSelectedFolder = newSelectedFolders?.[currentTabKey];
      reloadDocumentTab(
        currentSelectedFolder?.[currentSelectedFolder?.length - 1]?.id || '',
        1,
        mode
      );
      return newSelectedFolders;
    });
    setSelectedRowKeys((prevData) => {
      const newData = {
        ...prevData,
        [currentTabKey]: [],
      };
      return newData;
    });
    setSelectedRows((prevData) => {
      const newData = {
        ...prevData,
        [currentTabKey]: [],
      };
      return newData;
    });
  };
  const goToFile = (item, tFolders) => {
    const tRemainingFolders = (tFolders || []).map((obj) => ({
      ...obj,
      folderName: obj.name,
      parentId: obj.parentFolder?.id || 0,
    }));
    handleSelectFolder(null, tRemainingFolders);
  };
  const reloadDocumentTab = (tParentId, tPage, tMode) => {
    if (reloadAllFn?.fn) {
      if (tParentId) {
        reloadAllFn.filters.parentId = tParentId;
      } else {
        delete reloadAllFn.filters.parentId;
      }
      if (tMode) {
        reloadAllFn.filters.viewMode = tMode;
      }
      reloadAllFn.fn(productId, {
        ...reloadAllFn.filters,
        pageNo: tPage || reloadAllFn.filters.pageNo,
      });
    }
    if (loadExpiredFiles) loadExpiredFiles();
  };

  React.useEffect(() => {
    const initialSelected = Object.keys(files).reduce((acc, current) => {
      return { ...acc, [current]: [] };
    }, {});
    setSelected({ ...initialSelected, ...selected });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);
  React.useEffect(() => {
    const locationTab = viewLocation[0];
    if (locationTab) {
      const tab = tabs.findIndex(({ key }) => key === locationTab);
      if (tab > -1) {
        viewLocation.splice(0, 1);
        setActiveTab(locationTab);
        setCurrentTab(tab);
        const data = get(files, `${locationTab}.fileArr`);
        while (viewLocation.length) {
          const existedFolder = data.find(({ name }) => name === viewLocation[0]);
          if (!existedFolder) break;
          viewLocation.splice(0, 1);
          setFolders([...folders, { ...existedFolder, label: existedFolder.name }]);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, files, viewLocation]);
  React.useEffect(() => {
    const restTabs = productTabs
      .map((tab) => ({
        key: tab,
        label: tab,
        content: <FileManagement />,
        editable: true,
      }))
      .filter((tab) => {
        const indexOf = willDeletedTab.current.findIndex(({ value }) => value === tab.key);
        return indexOf < 0;
      });
    setTabs(TABS.concat(restTabs));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTabs]);
  React.useEffect(() => {
    handleShowUploadModal = null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.document}>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Breadcrumbs separator={<NavigateNextIcon />} className={classes.breadcrumb}>
          <Link color="inherit" href="/product/list">
            Product List
          </Link>
          {!currentSelectedFolders.length ? (
            <span>Document - {TAB_LABELS[currentTabKey]}</span>
          ) : (
            <Link
              color="inherit"
              onClick={() => {
                handleSelectFolder(null, []);
              }}>
              Document - {TAB_LABELS[currentTabKey]}
            </Link>
          )}
          {currentSelectedFolders.map((folder, index) => {
            return index === currentSelectedFolders.length - 1 ? (
              <span key={folder.id}>{folder.name}</span>
            ) : (
              <Link
                key={folder.id}
                color="inherit"
                onClick={() => {
                  const cloneFolders = [...currentSelectedFolders];
                  const remaining = cloneFolders.slice(0, index + 1);
                  handleSelectFolder(null, remaining);
                }}>
                {folder.name}
              </Link>
            );
          })}
        </Breadcrumbs>
        <Box>
          <SearchWithSuggestionProvider
            searchBy="name"
            onSearch={handleSearch}
            renderSuggestionItem={(item, refInput) => {
              const folders = item.location ? [item.location] : [];
              getParentFolders(item.location, folders);
              const sortedFolders = orderBy(folders, (tObj) => indexOf(folders, tObj), ['desc']);
              const locationPath =
                sortedFolders.length === 0
                  ? 'document'
                  : `/${sortedFolders.map((obj) => obj.name).join('/')}`;

              return (
                <ListItem
                  button
                  key={item.id}
                  className={classes.fileName}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    goToFile(item, sortedFolders);
                  }}>
                  <ListItemIcon>
                    {item.documentListId ? <Description></Description> : <Folder></Folder>}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.name || (item.documentList?.fileName || '').split(',')[1]}
                    secondary={locationPath}
                  />
                </ListItem>
              );
            }}>
            {({ onChange, onBlur, onFocus, search, refInput }) => {
              return (
                <SearchBox
                  ref={refInput}
                  onFocus={() => {
                    onFocus();
                  }}
                  onBlur={() => {
                    onBlur();
                  }}
                  onChange={onChange}
                />
              );
            }}
          </SearchWithSuggestionProvider>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" mt="24px">
        <Header
          disabled={editMode}
          title="Document"
          onClickMore={onClickMore}
          focusing={showMore}
          hiddenMore={true}
        />
        {editMode && (
          <Button
            className={classes.button}
            variant="contained"
            onClick={() => {
              setEditMode(false);
            }}>
            Done
          </Button>
        )}
        <Box flexGrow={1} display="flex" justifyContent="end">
          <QMASDocumentUpload
            featureFlags={['saveTo', 'reminder', 'compliance-data']}
            products={[product]}
            onUploadSuccess={() => {
              reloadDocumentTab(currentSelectedFolders?.[currentSelectedFolders?.length - 1]?.id);
            }}
            parentId={currentSelectedFolders?.[currentSelectedFolders?.length - 1]?.id}
            parentModule="product"
            buttonProps={{
              uploadButtonProps: {
                size: 'large',
                disabled: currentSelectedRows?.length > 0 || currentTabKey === TAB_KEYS.ARCHIVED,
              },
              newFolderButtonProps: hideNewUI
                ? undefined
                : {
                    size: 'large',
                    onClick: () => {
                      setIsAddNewFolder(true);
                    },
                    disabled:
                      currentSelectedRows?.length > 0 || currentTabKey === TAB_KEYS.ARCHIVED,
                  },
            }}
            actionCb={({ onShowUploadModal }) => {
              handleShowUploadModal = onShowUploadModal;
            }}
          />
        </Box>
      </Box>
      <Popover
        PaperProps={{ className: classes.wrapMenu }}
        disableAutoFocus
        disableEnforceFocus
        open={showMore}
        anchorEl={anchorEl}
        onClose={() => {
          setShowMore(false);
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <DocumentMenu
          menus={tabs.length > 3 ? MENUS : [MENUS[0]]}
          onClickMenuItem={(action) => {
            setShowMore(false);
            setAnchorEl(null);
            if (action === 'new-tab') {
              setAddingNewTab(true);
            }
            if (action === 'edit-tab') {
              setEditMode(true);
            }
          }}
        />
      </Popover>
      <DocumentsTab
        productId={productId}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        currentTabKey={currentTabKey}
        setCurrentTabKey={setCurrentTabKey}
        onSelectFolder={handleSelectFolder}
        selectedFolders={selectedFolders}
        onReloadCb={(tTabKey, fn, tFilters) => {
          if (tTabKey === TAB_KEYS.ALL_JOB) {
            reloadAllFn = {
              fn,
              filters: tFilters,
            };
          }
        }}
        allFiles={product?.files?.document?.fileArr}
        defaultSelectedFolders={currentSelectedFolders}
        loadExpiredFiles={loadExpiredFiles}
        onDropFiles={(tFiles) => {
          if (handleShowUploadModal) handleShowUploadModal(tFiles);
        }}
      />
      <AddNewModal
        onDelete={() => {
          setShowDeleteModal(true);
          setAddingNewTab(false);
        }}
        placeholder={T.translate('modal.tab.form.placeholder')}
        title={
          editItem && editMode
            ? T.translate('modal.tab.form.title.edit')
            : T.translate('modal.tab.form.title.new')
        }
        tabs={Object.keys(files)}
        open={addingNewTab}
        handleClose={() => {
          setAddingNewTab(false);
          setEditItem(null);
        }}
        item={editItem}
        createNew={(newTab, record) => {
          const fnCallback = () => {
            setAddingNewTab(false);
          };
          if (record) {
            const newTabs = tabs.map((tab, index) => {
              return {
                ...tab,
                label: record.id === index ? newTab : tab.label,
              };
            });
            setTabs([...newTabs]);
            setEditItem(null);
            onUpdateTab(
              {
                oldName: record.value,
                newName: newTab,
              },
              fnCallback
            );
          } else {
            onCreateTab(
              productId,
              {
                productId,
                tabName: newTab,
              },
              fnCallback
            );
            setTabs([...tabs, { label: newTab, editable: true }]);
          }
          enqueueSnackbar(`${record ? 'Update' : 'Created'} ${newTab} Tab`, {
            key: 'tab-success',
            variant: 'success',
            preventDuplicate: true,
            className: classes.snackbarSuccess,
            autoHideDuration: 3000,
            action: (
              <IconButton
                onClick={() => {
                  closeSnackbar('tab-success');
                }}>
                <CloseIcon />
              </IconButton>
            ),
          });
        }}
      />
      <DeleteModal
        open={showDeleteModal}
        handleClose={() => {
          setShowDeleteModal(false);
          setEditItem(null);
        }}
        item={editItem}
        onDelete={handleDeleteTab}
        title="Delete Tab?"
        body={
          <Box className={classes.messageDelete}>
            <Typography variant="body1">
              You’ll also delete all items in this tab, including:
            </Typography>
            <ul>
              <li>
                {get(files, `${editItem?.value}.fileArr`, []).filter(({ url }) => !url).length}{' '}
                folders
              </li>
              <li>
                {get(files, `${editItem?.value}.fileArr`, []).filter(({ url }) => !!url).length}{' '}
                files
              </li>
            </ul>
          </Box>
        }
      />

      {
        // Reuse Modal from Old UI.
      }
      <FileSystemNavigator
        open={openFilesNav}
        setOpen={setFilesNav}
        action={action}
        filesInit={{
          inspection: [],
          testing: [],
          design: [],
          materials: [],
          shipping: [],
          manufacturing: [],
          protocol: [],
        }}
        files={transformFiles}
        selected={selected}
        setSelected={setSelected}
        setShareFiles={setShareFiles}
        handleBulkDownload={() => {
          const ids = flattenDeep(
            Object.keys(selected).map((key) =>
              selected[key].filter((file) => !!file.id && !!file.url)
            )
          );
          onBulkDownload({ docIds: ids });
        }}
      />
      <ShareFiles
        id={productId}
        open={openShareFiles}
        setOpen={setShareFiles}
        setFilesNav={setFilesNav}
        companyId={companyId}
        selected={selected}
        setSelected={setSelected}
        onShare={(values, link, companyId) => {
          shareFile({
            value: values,
            link,
            companyId,
          });
        }}
      />
      {isAddNewFolder && (
        <NewFolderModal
          open
          onClose={() => {
            setIsAddNewFolder(false);
          }}
          onSubmit={(val, cb) => {
            const lastSelectedFolder =
              currentSelectedFolders[currentSelectedFolders.length - 1] || {};
            createProductFolder(
              {
                name: val,
                parentId: lastSelectedFolder?.id || 0,
                productId: Number(productId),
              },
              () => {
                reloadDocumentTab(currentSelectedFolders?.[currentSelectedFolders?.length - 1]?.id);
                if (cb) cb();
                setIsAddNewFolder(false);
              }
            );
          }}
        />
      )}
    </Box>
  );
};
export default DocumentSections;
